// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiftref-pagination i {
    border: solid var(--accent-strong-default);
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    position: relative;
    top: -2px;
}
.swiftref-pagination .disabled i {
    border-color: var(--text-default);
}

.swiftref-pagination .right {
    transform: rotate(-45deg);
    left: -1px;
}

.swiftref-pagination .left {
    transform: rotate(135deg);
    right: -1px;
}

.swiftref-pagination .up {
    transform: rotate(-135deg);
}

.swiftref-pagination .down {
    transform: rotate(45deg);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
